import { render } from "./TicketResultList.vue?vue&type=template&id=3572b136"
import script from "./TicketResultList.vue?vue&type=script&lang=js"
export * from "./TicketResultList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__